import { render, staticRenderFns } from "./DialogAddon.vue?vue&type=template&id=0edecf3d&scoped=true&"
import script from "./DialogAddon.vue?vue&type=script&lang=js&"
export * from "./DialogAddon.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/sass/style_custom.scss?vue&type=style&index=0&id=0edecf3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edecf3d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0edecf3d')) {
      api.createRecord('0edecf3d', component.options)
    } else {
      api.reload('0edecf3d', component.options)
    }
    module.hot.accept("./DialogAddon.vue?vue&type=template&id=0edecf3d&scoped=true&", function () {
      api.rerender('0edecf3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Products/DialogAddon.vue"
export default component.exports